import { ReplaySubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { CxsBreadcrumb } from '@features/layout/breadcrumb/breadcrumb.model';

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {
    private readonly breadcrumbRs$: ReplaySubject<CxsBreadcrumb[]> = new ReplaySubject();

    public breadcrumb$ = this.breadcrumbRs$.asObservable();

    public setBreadcrumb(breadcrumb: CxsBreadcrumb[]): void {
        if (!breadcrumb) {
            return;
        }

        this.breadcrumbRs$.next(breadcrumb);
    }
}
